@if (showSkeleton) { @for (item of skeletonItems; track item) {
<div class="-search-card-container loader">
  <div class="-search-card-header">
    <div class="skeleton-loader skeleton-title"></div>
    <div class="skeleton-loader skeleton-tag"></div>
  </div>
</div>
} } @else { @if (!toType || toType !== 'title') {
  <app-link [to]="isInternalDocumentUri ? searchCardResponse.documentBreadcrumbs : searchCardResponse.documentURI">
    @if (searchCardResponse) {
      <div class="-search-card-container">
        <div class="-search-card-header">
          <h3 [innerHTML]="title"></h3>
          <content-tag *ngIf="searchCardResponse.docCategory" [label]="searchCardResponse.docCategory"></content-tag>
        </div>
        <p class="-search-url">
          {{ searchCardResponse.documentBreadcrumbs }}
        </p>
        <p [innerHTML]="searchCardResponse.documentExcerpt"></p>
      </div>
    }
  </app-link>
}
@if (toType === 'title' && searchCardResponse) {
  <div class="-search-card-container">
    <div class="-search-card-header">
        <app-link [to]="isInternalDocumentUri ? searchCardResponse.documentBreadcrumbs : searchCardResponse.documentURI">
            <h3 [innerHTML]="title"></h3>
        </app-link>
        @if (searchCardResponse.docCategory) {
          <content-tag [label]="searchCardResponse.docCategory"></content-tag>
        }
    </div>
    <p class="-search-url">
      {{ searchCardResponse.documentBreadcrumbs }}
    </p>
    <p [innerHTML]="searchCardResponse.documentExcerpt"></p>
  </div>
} }